import React, {Component} from 'react'
import GA from  '../../components/GA/GA'
import SmoothEvent from '../../components/SmoothAnalytics/'
import './Services.css'

import iconAdditional from'../../images/additional.png'
import iconBathroom from'../../images/bathroom.png'
import iconBedroom from'../../images/bedroom.png'
import iconHallway from'../../images/hallway.png'
import iconKitchen from'../../images/kitchen.png'
import iconLivingRoom from'../../images/living-room.png'

import imageParty from'./party.jpg'
import imagePartyM from'./party-m.jpg'
import imageTenancy from'./tenancy.jpg'
import imageTenancyM from'./tenancy-m.jpg'
import imageMoving from'./moving.jpg'
import imageMovingM from'./moving-m.jpg'

class Services extends Component {

	componentDidMount(props){
		this.props.changePage('services')
		GA('Page: Services')
		SmoothEvent("pageload")
	}

	render(){

		return (
			<div className="page-container">

				<div className="content-spacer-1 spacer-bg-services"></div>

				<div className="content-container">

					<div className="content-container-background"></div>

					<div className="content-container-content">

	      				<h1>Services</h1>

	      				<br />

<h2>Domestic Cleaning</h2><br />
Fairy Clean offer regular domestic cleaning services weekly or fortnightly.
Our affordable services are made to meet up your particular requirements,
this ensures that we got the job done correctly first time we arrive.
A domestic cleaning service should operate with high values and customer satisfaction.
<br /><br />
<strong>Our domestic cleaning includes:</strong><br />
<br />

<div className="services-domestic">
<strong>Living Room</strong><br /><br />
<img src={iconLivingRoom} className="services-icon" alt="Living Room"/>
Dusting and wiping all accessible surfaces, polishing the furniture, wiping all skirting boards,
emptying the bins and vacuuming and mopping the floors.
</div>

<div className="services-domestic">
<strong>Kitchen</strong><br /><br />
<img src={iconKitchen} className="services-icon" alt="Kitchen"/>
Washing and loading the dishes, puting away dishes, wiping all surfaces, microwave interior/exterior,
cupboards only exterior, emptying bins, vacuuming and mopping the floor.
</div>

<div className="services-domestic">
<strong>Bedroom</strong><br /><br />
<img src={iconBedroom} className="services-icon" alt="Bedroom"/>
Change the bedding, dusting and polishing all surfaces, general tidy up, vacuuming and mopping the floor.
</div>

<div className="services-domestic">
<strong>Bathroom</strong><br /><br />
<img src={iconBathroom} className="services-icon" alt="Bathroom"/>
Scrubbing the bath and shower, cleaning the sink, wiping mirror, dusting all surfaces, cleaning and disinfecting
the toilet, vacuuming and mopping the floor.
</div>

<div className="services-domestic">
	<strong>Hallway</strong><br /><br />
	<img src={iconHallway} className="services-icon" alt="Hallway"/>
	Dusting and wiping all surfaces, wiping skirting board, vacuuming and mopping the floor.
</div>

<div className="services-domestic">
	<strong>Additional Services</strong><br /><br />
	<img src={iconAdditional} className="services-icon" alt="Additional"/>
	Laundry Wash & Dry<br />
	Cleaning Inside Oven<br />
	Inside Cabinets<br />
	Interior Walls<br />
	Inside Fridge & freezer<br />
	Interior Windows<br />
	Ironing<br />
</div>

<div className="breaker"></div>

<br />
<strong>What your professional cannot do?</strong><br />
Your professional do not offer a deep clean when you book a general clean.
This means no carpet cleaning, mould cleaning, outside window clean, no removal of deep stains.
Also, professionals do not lift and move furniture or vacuum and dust outside of the normal reach.<br />
<br /><br />

<h2>Deep Spring Cleaning</h2><br />
This is essentially a meticulous room by room cleaning.
We can provide all the materials and products for an extra fee or if you prefer the cleaners can use your equipment.<br />
<br /><br />

<h2>One-off cleaning</h2><br />
Depending on your preferences, your one off cleaning session may cover the entire property or focus on a specific area.<br />
<br /><br />

<h2>End of Tenancy Cleaning</h2><br />

<picture>
	<source srcSet={imageTenancyM} media="(max-width: 450px)" />
	<source srcSet={imageTenancy} />
	<img src={imageTenancy} className="services-image" alt="Tenancy" />
</picture>

We have designed a very comprehensive task list to meet the requirement standard if your check out.
<br /><br />
Our standard is high and is designed to meet the expectations of Landlords and Estate Agencies.
In order to satisfy both, the landlords and the tenants, we offer one of the best cleaning services in London.
<br /><br />
Our End of Tenancy Cleaning system provide the customers with great results in no time!
According to your Tenancy agreement you must leave the property exactly how you got it at first place.
This is not an easy task! You should not underestimate the difficulties that the End of Tenancy Cleaning hides.
<br /><br />
We have built up a strong and confident team of professional cleaners ready to deliver top notch services. If you are seeking for a perfect cleaning in the area of London, you will not make a mistake hiring us!
<br /><br />
<strong>Our End of Tenancy Cleaning Service includes:</strong>
<br /><br />
<strong>Bedroom/Lounge Cleaning</strong> – all reachable surfaces wiped and dusted. Door handles, light switches and glass fixtures cleaned. Cobwebs, wall marks removed. Window sills and skirting boards dusted and wiped. Floors vacuumed and mopped.
<br /><br />
<strong>Kitchen Cleaning</strong> – reachable flat areas wiped and cleaned including countertops, table, chairs and appliances. Oven, microwave and cupboards cleaned inside and outside. Wall marks and cobwebs cleaned. Floor vacuumed and mopped .
<br /><br />
<strong>Bathroom Cleaning</strong> – bathtub or shower screen scrubbed and cleaned. Toilet, sink and vanity cabinet scrubbed and sanitised. Mirrors wiped. Fittings and tiles wiped and polished. Floor vacuumed and mopped.
<br /><br />
<strong>Common areas Cleaning</strong> – door handles, light switches and glass fixtures cleaned. Marks and cobwebs removed. Skirting boards and window sills wiped and cleaned. Flooring vacuumed and mopped.
<br /><br />

<h2>Move In/Out Cleaning</h2><br />

<picture>
	<source srcSet={imageMovingM} media="(max-width: 450px)" />
	<source srcSet={imageMoving} />
	<img src={imageMoving} className="services-image" alt="Moving In/Out" />
</picture>

Our services are customised to complement each of our customers and individual requirements.
<br /><br />
The opportunities with this cleaning service are endless:
<br /><br />
Help with packing your belongings if you are moving home. They will simply follow orders and be extremely careful packing your life away.
<br /><br />
Help unpack your boxes full with your belongings into your new home and precisely put them away in accordance to your instructions and specifications.
<br /><br />
They can clean your storages, for example rearrange your cupboards, kitchen drawers or wardrobes, as the content will be taken out and cleaned inside the cupboard, drawer and wardrobe. After that they will put your belongings back in a perfect order and leave you with refreshed kitchen or bedroom storage.
<br /><br />
Cleaning basements and lofts is our cleaner for one day specialty and they will help with utmost pleasure if for example if your wine cellar is in need of a proper dusting or there is a need of cleaning behind the bed in your loft, where your kids have been playing or storing their toys.
<br /><br />
This cleaning service will ensure top to bottom property cleaning as well as tidying and rearranging your home should there is a need for it.
<br /><br />


<h2>Before / After Party Cleaning</h2><br />

<picture>
	<source srcSet={imagePartyM} media="(max-width: 450px)" />
	<source srcSet={imageParty} />
	<img src={imageParty} className="services-image" alt="Party" />
</picture>

We provide before, during and after party help and cleaning services so you can relax and enjoy the party.
<br /><br />
Your party was great and your guests had a wonderful time. But now it’s over. The daunting time begins – the after party cleaning. But it doesn’t have to be that bad after all. That is why we at Fairy Clean have designed our professional after party cleaning services in London to deal with the messy aftermath instead of you.
<br /><br />
In case you need a cleaning before the party, trust our before party cleaning services in London. Rest assured we will give your property the sparkle it needs for the upcoming event. Our professional cleaning team will dust wherever needed, help you put the decoration up and assist you every step of the way in your party preparation. They are friendly, motivated and will follow your instructions impeccably.
<br /><br />
We guarantee you a high standard of cleaning services every time you call us. Fairy Clean is always one step ahead making sure our customers are fully satisfied and find every cleaning service they need, when they need it. We guarantee to organise cleaning teams at a short notice and ensure the quality remains high at all times. Book our after party cleaning treatment now and the benefits that comes with it are endless.
<br /><br />
Choose our after party cleaning services and we promise a stress free event planning and preparation. Our professional London party cleaners are reliable and hardworking. They make sure each corner is spotless.
<br /><br />

<h2>Other Cleaning Services</h2><br />
We provide all aspects of cleaning: offices, shops, staircases, building sites, communal areas.<br />
<br />
Whether you need anything from routine daily cleaning programs to less frequent maintenance cleaning, we have you covered.
<br /><br />
Our standard professional office-cleaning/ shops/communal area services consist of normal day-to-day duties: trash pickup, floor mopping, vacuuming, interior window-washing, and bathroom, kitchen maintenance.
<br /><br />
We specialise in keeping your business environment clean and healthy for your employees and customers.<br />
<br /><br />



	      				<div className="cleaning-tips-container">
	      					<div className="cleaning-tip-icon"></div>
							<i>
							Whitening the grounding between the tiles: make a paste of equal parts lemon juice, vinegar and bicarb and scrub grout with a soft toothbrush then rinse.
							</i>
							<div className="breaker"></div>
						</div>

					</div>
				</div>

			</div>
		)
	}
}

export default Services


// WEBPACK FOOTER //
// ./src/pages/Services/Services.js